<template>
  <div class="auth-shell">
    <div class="auth-card surface-elevated">
      <div class="brand-wrap">
        <img class="brand-logo" src="@/assets/images/logo.png" alt="BestPhone" />
      </div>

      <div class="stack-sm auth-header">
        <h1 class="display-title">{{ get_word('reset_password_title') || 'איפוס סיסמה' }}</h1>
        <p class="muted">{{ get_word('reset_password_subtitle') || 'בחרו סיסמה חדשה לחשבון שלכם.' }}</p>
      </div>

      <div v-if="tokenError" class="error-inline" style="margin-bottom:1rem;">
        {{ tokenError }}
      </div>

      <form v-else class="auth-form stack-md" @submit.prevent="submitReset">
        <div class="field">
          <label class="form-label">{{ get_word('new_password') || 'סיסמה חדשה' }}</label>
          <div class="password-field">
            <input
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              class="input-control"
              :placeholder="get_word('new_password_placeholder') || 'לפחות 6 תווים'"
              required
            />
            <button type="button" class="password-toggle" @click="showPassword = !showPassword">
              {{ showPassword ? 'הסתר' : 'הצג' }}
            </button>
          </div>
          <small v-if="errors.password" class="help-error">{{ errors.password }}</small>
        </div>

        <div class="field">
          <label class="form-label">{{ get_word('confirm_password') || 'אימות סיסמה' }}</label>
          <div class="password-field">
            <input
              v-model="form.password_confirm"
              :type="showConfirm ? 'text' : 'password'"
              class="input-control"
              :placeholder="get_word('confirm_password_placeholder') || 'הקלידו שוב את הסיסמה'"
              required
            />
            <button type="button" class="password-toggle" @click="showConfirm = !showConfirm">
              {{ showConfirm ? 'הסתר' : 'הצג' }}
            </button>
          </div>
          <small v-if="errors.password_confirm" class="help-error">{{ errors.password_confirm }}</small>
        </div>

        <button type="submit" :disabled="loading" class="btn btn-primary auth-submit">
          <span v-if="!loading">{{ get_word('save_password') || 'שמירת סיסמה והמשך' }}</span>
          <span v-else>{{ get_word('loading') || 'שומר...' }}</span>
        </button>

        <div v-if="generalError" class="error-inline">{{ generalError }}</div>
      </form>

      <div class="auth-footer">
        <router-link to="/login" class="footer-link">{{ get_word('back_to_login') || 'חזרה להתחברות' }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    return {
      token: '',
      form: { password: '', password_confirm: '' },
      loading: false,
      showPassword: false,
      showConfirm: false,
      errors: {},
      generalError: '',
      tokenError: ''
    }
  },
  mounted() {
    this.token = this.$route.query.token || ''
    if (!this.token) {
      this.tokenError = 'קישור לא תקין. בקשו קישור חדש.'
    }
  },
  methods: {
    submitReset() {
      this.errors = {}
      this.generalError = ''

      if (!this.form.password) {
        this.errors.password = 'יש להזין סיסמה חדשה'
        return
      }
      if (this.form.password.length < 6) {
        this.errors.password = 'הסיסמה חייבת להכיל לפחות 6 תווים'
        return
      }
      if (!this.form.password_confirm) {
        this.errors.password_confirm = 'יש להזין אימות סיסמה'
        return
      }
      if (this.form.password !== this.form.password_confirm) {
        this.errors.password_confirm = 'הסיסמאות אינן תואמות'
        return
      }

      this.loading = true
      this.api({
        action: 'reset_password',
        data: {
          token:            this.token,
          password:         this.form.password,
          password_confirm: this.form.password_confirm
        },
        method: 'post'
      }, (response) => {
        if (response?.data?.success) {
          this.activateSuccess('הסיסמה אופסה בהצלחה! מעביר להתחברות...')
          setTimeout(() => this.$router.push('/login'), 1200)
          return
        }

        const err = response?.data?.error
        if (err === 'token_expired') {
          this.tokenError = 'הקישור פג תוקף. בקשו קישור חדש מדף שכחתי סיסמה.'
        } else if (err === 'invalid_token') {
          this.tokenError = 'קישור לא תקין. בקשו קישור חדש.'
        } else if (err === 'password_too_short') {
          this.errors.password = 'הסיסמה חייבת להכיל לפחות 6 תווים'
        } else if (err === 'password_mismatch') {
          this.errors.password_confirm = 'הסיסמאות אינן תואמות'
        } else {
          this.generalError = 'האיפוס לא הצליח. נסו שוב.'
        }
        this.loading = false
      }, () => {
        this.generalError = 'שגיאה. נסו שוב.'
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.auth-submit { width: 100%; }

.password-field {
  position: relative;
}

.password-toggle {
  position: absolute;
  inset-inline-end: 0.65rem;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: #8424e3;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}

.brand-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.brand-logo {
  width: 168px;
  max-width: 74%;
  object-fit: contain;
}

.auth-footer {
  margin-top: 1rem;
  text-align: center;
}

.footer-link {
  color: #8424e3;
  font-size: 0.9rem;
  font-weight: 600;
}

.error-inline {
  border: 1px solid #f0bfd0;
  background: #fff4f8;
  color: #9f2f50;
  border-radius: 10px;
  padding: 0.65rem 0.85rem;
  font-size: 0.9rem;
}
</style>
